module.exports = __webpack_public_path__ + "static/media/detailed-organic-keywords-sample.5dd73ffa.png";